import React from 'react';
import { useTheme } from '@mui/material/styles';
import type { ThemedSvgProps } from '../../types';

const BallPitBallsBase: React.FC<ThemedSvgProps> = ({ color, size = 60, className }) => {
  const theme = useTheme();
  const fill = color || theme.palette.venue.kids;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="presentation"
      className={className}
    >
      {/* Ball 1 - large, full color */}
      <circle cx="38" cy="55" r="20" fill={fill} opacity={1.0} />
      <circle cx="30" cy="47" r="5" fill="white" opacity={0.2} />

      {/* Ball 2 - medium, slightly transparent */}
      <circle cx="65" cy="60" r="17" fill={fill} opacity={0.7} />
      <circle cx="59" cy="53" r="4" fill="white" opacity={0.2} />

      {/* Ball 3 - small, lighter */}
      <circle cx="55" cy="32" r="15" fill={fill} opacity={0.5} />
      <circle cx="49" cy="26" r="4" fill="white" opacity={0.2} />

      {/* Ball 4 - medium-small, full color */}
      <circle cx="25" cy="30" r="13" fill={fill} opacity={0.85} />
      <circle cx="20" cy="25" r="3" fill="white" opacity={0.2} />

      {/* Ball 5 - small, faded */}
      <circle cx="80" cy="38" r="12" fill={fill} opacity={0.6} />
      <circle cx="76" cy="33" r="3" fill="white" opacity={0.2} />

      {/* Ball 6 - tiny accent */}
      <circle cx="78" cy="75" r="14" fill={fill} opacity={0.4} />
      <circle cx="73" cy="69" r="3.5" fill="white" opacity={0.2} />
    </svg>
  );
};

export const BallPitBalls = React.memo(BallPitBallsBase);
